"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _material = require("@mui/material");

var _jsxRuntime = require("react/jsx-runtime");

var StyledPaper = (0, _material.styled)(_material.Paper)(function (_ref) {
  var theme = _ref.theme;
  return {
    background: theme.palette.background.default,
    display: "flex",
    height: "calc(100vh - ".concat(theme.mixins.toolbar.minHeight, "px - 2px)"),
    marginTop: 2 // Space for the NavBar's shadow

  };
});

var PageLayout = function PageLayout(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPaper, {
    square: true,
    children: children
  });
};

var _default = PageLayout;
exports.default = _default;